import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineAccordion } from 'src/components/base/outline-accordion/outline-accordion';
import '../idb-heading/idb-heading';
import '../../base/outline-container/outline-container';
import componentStyles from './idb-accordion.css.lit';

/**
 * The IdbAccordion component
 * @element idb-accordion
 */
@customElement('idb-accordion')
export class IdbAccordion extends OutlineAccordion {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Boolean, attribute: 'condensed' })
  condensed = false;

  connectedCallback(): void {
    super.connectedCallback();
    this.singlePanel = false;
    this.clean = true;
  }

  render(): TemplateResult {
    return html`
    <div class="wrapper">
      <outline-container x-padding>
        <div class="header-section ${
          this.condensed ? 'accordion-condensed' : ''
        }">
          ${this._conditionalSlotTemplate({
            slotName: 'heading',
          })}
          ${this._conditionalSlotTemplate({
            slotName: 'eyebrow',
          })}
        </div>
        <div class="accordion ${
          this.condensed ? 'accordion-condensed' : ''
        }" @keydown=${this.handleKeyboardNav}>
          <slot name="panels"></slot>
        </div>
        
      </outline-container>
    </div>
    `;
  }
}
